import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { generateClient } from "aws-amplify/api";
import { listAgreements, listContents } from "../../graphql/queries";
import { deleteAgreement, deleteContent } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import { Delete, Edit } from "@mui/icons-material";
import Label from "../../components/Label";
import CustomDataGrid from "../../components/CustomDataGrid";
import Box from "@mui/material/Box";
import moment from "moment";
import ActionsPopover from "../../components/actionsPopover";import { toast } from "react-toastify";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  dataGridContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  dataGrid: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      "& .MuiDataGrid-columnHeaders": {
        display: "none",
      },
      "& .MuiDataGrid-cell": {
        display: "block",
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
        "&:not(:last-child)": {
          borderBottom: 0,
        },
        "&:before": {
          content: "attr(data-field)",
          fontWeight: "bold",
          marginBottom: theme.spacing(1),
        },
      },
    },
  },
}));

const Agreements = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const client = generateClient();
  const [contentList, setContentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  useEffect(() => {
    fetchCategory();
  }, [deleteSuccess]);

  const deleteAgreementById = async (id) => {
    try {
      const response = await client.graphql({
        query: deleteAgreement,
        variables: {
          input: {
            id: id,
          },
        },
      });
      if (response.data.deleteAgreement) {
        setDeleteSuccess(!deleteSuccess);
        toast.success("Agreement Has Been Deleted!");
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error.message);
    }
  };

  const fetchCategory = async () => {
    try {
      setLoading(true);
      const response = await client.graphql({
        query: listAgreements,
      });
      const contentList = response.data.listAgreements.items;
      setContentList(contentList);
    } catch (error) {
      console.error("Error fetching category:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "daysOfAgreement",
      headerName: "Term Of Agreement",
      flex: 1,
      renderCell: (params) => <div>{params?.value / 30} months</div>,
    },
    { field: "licensingRegion", headerName: "Target Region", flex: 1 },
    {
      field: "numberOfRefreshCycles",
      headerName: "Refresh Cycles",
      flex: 1,
    },

    { field: "contractValue", headerName: "Contract Value ($)", flex: 1 },
    { field: "paymentStatus", headerName: "Payment Status", flex: 1 },
    {
      field: "paymentPlan",
      headerName: "Payment Plan",
      flex: 1,
    },
    {
      field: "paymentTerm",
      headerName: "Payment Term",
      flex: 1,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      renderCell: (params) => (
        <div>{moment(params?.value).format("DD MMM YYYY")}</div>
      ),
    },
    {
      field: "actions",
      headerName: "Edit Content",
      flex: 1,
      renderCell: (params) => (
        <ActionsPopover
          itemId={params.row.id}
          viewPath={`/agreement/${params.row.id}`}
          editPath={`/agreement/edit/${params.row.id}`}
          canDelete={true}
          onDelete={deleteAgreementById}
        />
      ),
    },
  ];

  return (
    <>
      <Box marginTop={2}>
        <div className={classes.dataGridContainer}>
          <CustomDataGrid rows={contentList} columns={columns} pageSize={10} />
        </div>
      </Box>
    </>
  );
};

export default Agreements;
